const gridAutoColumns = {
    name: "grid-auto-columns",
    path: "/grid-auto-columns",
    title: "grid-auto-columns",
    description: "Utilities for controlling the size of implicitly-created grid columns.",
    value: {
       "grid-auto-columns": {
          "auto-columns-auto": "auto",
          "auto-columns-min": "min-content",
          "auto-columns-max": "max-content",
          "auto-columns-fr": "minmax(0, 1fr)",
          "auto-columns-[<value>]": " <value>"
        },
    },
    exampleData: [
        {
            "title": "auto-columns-min, auto-columns-max",
            "description": "to control the size of implicitly-created grid columns:",
            "example": {
                "code": `
<div class="grid auto-columns-max grid-flow-col">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>
                `
            },
        },
        {
            "title": "auto-columns-[<value>]",
            "description": "syntax to set the size of implicitly-created grid columns based on a completely custom value:",

            "example": {
                "code": `
<div class="auto-columns-[minmax(0,2fr)] ...">
  <!-- ... -->
</div>        `
            },
        }
    ],
};

export default gridAutoColumns;